module.exports = __webpack_public_path__ + "static/media/logo_transbg250.9105b0a5.png";